
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../lib/data";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
                ? "bg-[#040814]/80 backdrop-blur-xl border-b border-white/5"
                : "bg-transparent"
                }`}
        >
            <nav className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
                <button
                    data-testid="logo-btn"
                    onClick={() => scrollTo("home")}
                    className="flex items-center gap-2 group"
                >
                    <img src="/logo.png" alt="RS Web Studio logo" className="h-12 w-auto" />
                    {/* <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center font-black text-[#040814] text-lg shadow-lg shadow-cyan-500/20 group-hover:shadow-cyan-500/40 transition-shadow">
                        R
                    </div>
                    <span className="font-bold text-lg tracking-tight hidden sm:inline">
                        RS Digital <span className="text-cyan-400">Studio</span>
                    </span> */}
                </button>

                <ul className="hidden lg:flex items-center gap-1">
                    {NAV_LINKS.map((l) => (
                        <li key={l.id}>
                            <button
                                data-testid={`nav-${l.id}`}
                                onClick={() => scrollTo(l.id)}
                                className="px-4 py-2 text-sm text-slate-300 hover:text-cyan-400 transition-colors rounded-md"
                            >
                                {l.label}
                            </button>
                        </li>
                    ))}
                </ul>

                <div className="flex items-center gap-3">
                    <a
                        data-testid="nav-cta-calendly"
                        href='https://calendly.com/rsdwebstudio/30min'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-cyan-400 text-[#040814] font-semibold text-sm hover:bg-cyan-300 transition-all hover:shadow-lg hover:shadow-cyan-500/30"
                    >
                        Book a free consultation
                    </a>
                    <button
                        data-testid="nav-mobile-toggle"
                        onClick={() => setOpen(!open)}
                        className="lg:hidden p-2 text-white"
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </nav>

            {open && (
                <div className="lg:hidden bg-[#040814]/95 backdrop-blur-xl border-t border-white/5">
                    <ul className="px-6 py-4 space-y-1">
                        {NAV_LINKS.map((l) => (
                            <li key={l.id}>
                                <button
                                    data-testid={`mobile-nav-${l.id}`}
                                    onClick={() => scrollTo(l.id)}
                                    className="w-full text-left px-4 py-3 text-slate-300 hover:text-cyan-400 hover:bg-white/5 rounded-md transition"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                        <li className="pt-3">
                            <a
                                data-testid="mobile-cta-calendly"
                                href="https://calendly.com/rsdwebstudio/30min"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block w-full text-center px-5 py-3 rounded-full bg-cyan-400 text-[#040814] font-semibold"
                            >
                                Book a free consultation
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </header>
    );
};